"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormTracker = void 0;
const dataLayer_1 = require("../../util/dataLayer");
const index_1 = require("../fields/index");
const VALID_MODULE_TYPES = [
    'registration',
    'lead',
    'form_option',
    'prospect',
    'applicant',
    'quote',
    'calculator',
    'download',
    'tax_quiz',
    'assessment quiz'
];
const createFormTracker = ({ formId }) => {
    const trackStepView = ({ stepName }) => {
        dataLayer_1.default.push({ event: 'formStepView', formId, formStepName: stepName });
    };
    const trackStepSkip = ({ stepName }) => {
        dataLayer_1.default.push({ event: 'formStepSkip', formId, formStepName: stepName });
    };
    const trackValidSubmission = ({ emailAddress } = {}) => {
        dataLayer_1.default.push({
            event: 'formSubmissionAttempt',
            formId,
            formEmail: emailAddress
        });
        dataLayer_1.default.push({
            event: 'formSubmission',
            formId,
            formEmail: emailAddress
        });
    };
    const trackInvalidSubmission = () => {
        dataLayer_1.default.push({ event: 'formSubmissionAttempt', formId });
    };
    const trackConfirmation = ({ referenceId, score }) => {
        if (!referenceId && !score) {
            throw new Error('Must provide referenceId and/or score');
        }
        dataLayer_1.default.push({ event: 'formConfirmation', formId, referenceId, score });
    };
    const trackModule = ({ type, category, label, value }) => {
        if (!type || !category || !label) {
            throw new Error('Must provide type, category, and label');
        }
        if (!VALID_MODULE_TYPES.includes(type)) {
            throw new Error(`Module type must be one of ${VALID_MODULE_TYPES}`);
        }
        dataLayer_1.default.push({
            event: 'formModule',
            formId,
            moduleType: type,
            moduleCategory: category,
            moduleLabel: label,
            moduleValue: value
        });
    };
    const interactedFields = [];
    const registerFormElement = (formElement) => {
        const handleFocus = ({ target }) => {
            const formField = target;
            if (interactedFields.length === 0) {
                dataLayer_1.default.push({ event: 'formStart', formId });
            }
            if (interactedFields.includes(formField))
                return;
            interactedFields.push(formField);
            const formFieldName = (0, index_1.getFieldName)(formField);
            if (!formFieldName)
                return;
            const formFieldIndex = (0, index_1.getFieldIndex)(formField, formElement);
            dataLayer_1.default.push({
                event: 'formInteraction',
                formId,
                formFieldName,
                formFieldIndex
            });
        };
        formElement.addEventListener('focus', handleFocus, true);
    };
    const trackError = ({ field, message }) => {
        dataLayer_1.default.push({
            event: 'formError',
            formId,
            errorField: (0, index_1.getFieldName)(field),
            errorMessage: message
        });
    };
    return {
        trackConfirmation,
        trackError,
        trackInvalidSubmission,
        trackModule,
        trackStepSkip,
        trackStepView,
        trackValidSubmission,
        registerFormElement
    };
};
exports.createFormTracker = createFormTracker;
